import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as propTypes from 'prop-types';

const FormWrapperComponent = ({ children }) => (
    <div className="sid sid-form-wrapper">
        {children}
    </div>
);

FormWrapperComponent.propTypes = {
    children: propTypes.any.isRequired,
};

export { FormWrapperComponent };
